import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { ManagementService } from '../_service/management.service';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule,ReactiveFormsModule} from '@angular/forms';
import { JwtUtilsService } from '../_service/jwt-utils.service';
import { Router } from '@angular/router';
import { Select2Data, Select2Module, Select2UpdateEvent, Select2UpdateValue } from 'ng-select2-component';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { RegistryComponent } from "../registry/registry.component";

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.css'],
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatTableModule, MatSortModule, MatPaginatorModule, CommonModule, FormsModule, ReactiveFormsModule, Select2Module, TranslateModule, RegistryComponent]
})
export class ManagementComponent implements AfterViewInit{
  levelsForm: FormGroup;
  displayedColumns: string[] = ['id', 'url', 'active', 'actions'];
  columnsProperties: string[] = ['propertyName', 'value', 'actions'];
  columnsTemplates: string[] = ['id', 'service', 'templateName', 'actions']

  loggedUser:any = undefined;
  dataSource: MatTableDataSource<any>;
  dataSourceProperties: MatTableDataSource<any>;
  dataSourceServices: Map<string, MatTableDataSource<any>>;
  dataSourceSelectData: Map<string, Select2Data>;

  myDate: Date = new Date();
  limits = [0,5];
  propertiesLimits = [0,5]
  baseData: any[] = [];
  propertyData: any[] = [];
  @ViewChildren(MatPaginator) paginator: QueryList<MatPaginator>;
  @ViewChildren(MatSort) sort: QueryList<MatSort>;

  @ViewChildren("services") divs: QueryList<ElementRef>;

  paginatorServices: QueryList<MatPaginator>;
  scheduler = "";
  editedProperty: any;
  classLog = "es.oots";
  levels = ["INFO", "DEBUG", "ERROR"];
  types = [{name: "all", selected: true}]
  popUp = {show: false, title: "", message: ""}
  purgeScheduler = "";
  dbCleanerDays = 0;
  section = "whitelist"
  servicesStates: Map<string, any>
  servicesDataMap: Map<string, any> = new Map<string, any>([["Procedures", ["id", "code", "description", "actions"]], ["Requirements", ["id", "requirementId", "description", "actions"]], 
    ["ProcedureRequirements", ["id", "procedureId", "requirementId", "actions"]], ["PidServiceCatalog", ["id", "serviceName", "pidServiceId", "endpointUrl", "actions"]], 
    ["RequirementPidCatalog", ["id", "requirementId", "pidServiceId", "actions"]]]);
  serviceTypesLeft: string[] = [];
  serviceTypesRight: string[] = [];

  serviceTypesLeftFinal: string[] = ["Procedures","Requirements","PidServiceCatalog"];
  serviceTypesRightFinal: string[] = ["ProcedureRequirements", "RequirementPidCatalog"];

  visibleInputs = false;
  visibleInputsProperties = false;
  urlInput:string;
  isActive = true;
  menuShow = false;
  loadedData = false;
  editedEntry: any;
  editedValues: any;
  validationStatus = false;

  data: Select2Data;
  private subscription: Subscription;

  constructor(private managementService: ManagementService, private router: Router, private jwtUtilsService: JwtUtilsService, private fb: FormBuilder, private changeDetectorRef: ChangeDetectorRef){}
  ngAfterViewInit() {
    this.managementService.getLoggedUser().subscribe({
      next: result => {
        //Delete or comment for deployment and pushing to repo, uncomment for development purposes only
           this.loggedUser = {
            username: "A user",
            role: "ROLE_ADMIN"
          };
        
        
        //this.loggedUser = result;
        this.getTypes();
        this.initWhitelist();
        this.loadServicesLists();
      }
    })
    this.subscription = this.divs.changes.subscribe({
      next: () => {
        if (this.divs.length > 0) {
          this.changeDetectorRef.detectChanges();
          if(this.section == "services") this.loadServicesLists();
        }
      }
    });
  }

  initWhitelist(){
    this.section='whitelist'; 
    this.menuShow=false;
    this.loadedData=false;
    this.search();
  }

  initProperties(){
    this.section='properties'; 
    this.menuShow=false; 
    this.loadedData=false;
    this.searchProperties();
    this.scheduler = "";
    this.purgeScheduler = "";
    this.getValidationStatus();
    this.getScheduler("MessageRetrieverService");
    this.getScheduler("DBCleanerService");
    this.getDbCleanerDays();
    this.logLevelMethods();
  }

  initTemplate(){
    this.section = 'template'
    this.menuShow=false; 
    this.loadedData=false;
    this.editedEntry = {};
    this.listTemplates();
  }

  getValidationStatus(){
    this.managementService.getCommonServiceValidationStatus().subscribe({ next: value => {
        this.validationStatus = value;
      }
    })
  }

  search() {
    this.loadedData = true;
    this.managementService.getWhitelist(this.limits).subscribe(
      {
         next: result => {
          this.baseData = result;
          this.dataSource = new MatTableDataSource(result);
          this.dataSource.paginator = this.paginator.toArray()[0];
          this.dataSource.sort = this.sort.toArray()[0];
         }
      }
    )
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  nextPage(event: PageEvent) {
    this.limits[0] = event.pageIndex * event.pageSize;
    this.limits[1] = event.pageSize;
    this.search();
  }

  nextPageProperties(event: PageEvent) {
    this.propertiesLimits[0] = event.pageIndex * event.pageSize;
    this.propertiesLimits[1] = event.pageSize;
    this.searchProperties();
  }

  delete(id:number){
    this.managementService.deleteWhitelistEntry(id).subscribe({next: () => {
      this.search()
    }})
  }

  saveEdit(id: number){
    const whitelistEntry =
    {
      "id": id,
      "url": this.urlInput,
      "active": this.isActive 
    }
    this.managementService.saveWhitelistEntry(whitelistEntry).subscribe({next: () => {
      this.visibleInputs = false;
      this.search();
    }})
  }

  save(){
    const whitelistEntry =
    {
      "url": this.urlInput,
      "active": this.isActive 
    }
    this.managementService.saveWhitelistEntry(whitelistEntry).subscribe({next: () => {
      this.visibleInputs = false;
      this.limits[0] = 0;
      this.search();
    }})
  }

  setSaving(){
    const math = Math;
    this.visibleInputs = true;
    this.managementService.getWhitelistLength().subscribe(
      {
         next: result => {
          let limit = math.trunc(result/this.limits[1]);
          limit ++;
          this.limits[0] = limit * this.limits[1];
          this.managementService.getWhitelist(this.limits).subscribe(
            {
               next: result => {
                this.baseData = result;
                this.dataSource = new MatTableDataSource(result);
                const extendedData = this.baseData;
                extendedData.push({id: "", url: "", active:false, actions: "new"});
                this.dataSource = new MatTableDataSource(extendedData);
               }
            }
          )
         }
      }
    )
  }

  applyFilterProperties(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceProperties.filter = filterValue.trim().toLowerCase();

    if (this.dataSourceProperties.paginator) {
      this.dataSourceProperties.paginator.firstPage();
    }
  }

  cancelSave(){
    this.dataSource = new MatTableDataSource(this.baseData);
    this.visibleInputs = false;
    this.limits[0] = 0;
    this.search();
  }
  
  changeScheduler(taskName: string){
    if(taskName == "MessageRetrieverService"){
      this.managementService.changeScheduler(this.scheduler, taskName).subscribe({next: () => {
        this.getScheduler("MessageRetrieverService");
        this.visibleInputs = false;
        this.limits[0] = 0;
      }})
    }
    else if(taskName == "DBCleanerService"){

      this.managementService.changeScheduler(this.purgeScheduler, taskName).subscribe({next: () => {
        this.getScheduler("DBCleanerService");
        this.visibleInputs = false;
        this.limits[0] = 0;
      }})
      
    }
    
  }
  searchProperties() {
    const selType = this.types.filter(type => type.selected).at(0)?.name
    this.loadedData=true;
    this.managementService.getProperties(selType).subscribe(
      {
         next: result => {
          this.propertyData = result;
          this.dataSourceProperties = new MatTableDataSource(result);
          this.dataSourceProperties.paginator = this.paginator.toArray()[0];
          this.dataSourceProperties.sort = this.sort.toArray()[0];
         }
      }
    )
  }

  setServiceEditedProperty(property:any){
    this.editedProperty = structuredClone(property);
    this.visibleInputsProperties = true;
    delete this.editedProperty.actions;
  }

  saveEditedProperty(){
    const property = this.editedProperty;
    this.managementService.savePropertiesEntry(property).subscribe({next: () => {
      this.visibleInputsProperties = false;
      this.editedProperty = undefined;
      this.searchProperties();
    }});
  }

  logout(){
    this.managementService.logoutUser().subscribe({next: () => {
        this.router.navigate(['/login-maintenance']);
      },
      error: () =>{
        this.router.navigate(['/login-maintenance'])
      }
    });
  }

  logLevelMethods(loglevel?:string){
    this.managementService.logLevelServices(this.classLog, loglevel).subscribe({next: response => {
      if(loglevel){
        this.popUp = {show: true, title: "Log level changed", message: response + ""}
        setTimeout(() => this.popUp.show = false, 4000);
      }
      else{
        this.levelsForm = this.fb.group({
          levelControl: [response]
        })
      }
    }})
  }

  getTypes(){
    this.managementService.getPropertyTypes().subscribe(
      {
         next: result => {
          result.forEach((type: string) => {
            this.types.push({name: type, selected: false})
          })
         }
      }
    )
  }

  getDbCleanerDays(){
    this.managementService.getDBCleanerDays().subscribe(
      {
         next: result => {
          this.dbCleanerDays = result;
         }
      }
    )
  }

  changeDbCleanerDays(){
    this.managementService.changeDBCleanerDays(this.dbCleanerDays).subscribe(
      {next: () => {
        this.popUp = {show: true, title: "Purge maximum age changed", message: "Purge maximum age changed time changed to " + this.dbCleanerDays + " days"}
          setTimeout(() => this.popUp.show = false, 4000);
      }}
    )
  }

  getScheduler(taskName: string){
    this.managementService.getScheduler(taskName).subscribe({ next: result => {
      if(taskName == "MessageRetrieverService"){
        if(this.scheduler != ""){
          this.scheduler = result;
          this.popUp = {show: true, title: "Scheduler changed", message: "Scheduler time changed to " + this.scheduler + "ms"}
          setTimeout(() => this.popUp.show = false, 4000);
        }
        else this.scheduler = result;
      }
      else if(taskName == "DBCleanerService"){
        if(this.purgeScheduler != ""){
          this.purgeScheduler = result;
          this.popUp = {show: true, title: "Purge scheduler changed", message: "Purge scheduler time changed to " + this.purgeScheduler}
          setTimeout(() => this.popUp.show = false, 4000);
        }
        else this.purgeScheduler = result;
      }
    }});
  }

  changeType(index: number){
    this.types.forEach(type => {type.selected = false})
    this.types[index].selected = true;
    this.searchProperties();
  }

  capitalize(str: string){
    return String(str).charAt(0).toUpperCase() + String(str).slice(1)
  }

  initServices(){
    this.section='services'; 
    this.menuShow=false; 
    this.loadedData=false;
    this.loadServicesLists();
  }

  initSingleService(serviceType :string){
    this.section='singleService'; 
    this.menuShow=false; 
    this.loadedData=false;
    this.loadService(serviceType);
  }

  loadService(serviceType :string){
    this.serviceTypesLeft = [];
    this.serviceTypesRight = [];
    this.serviceTypesLeft = this.serviceTypesLeftFinal.filter( (type) => type===serviceType);
    this.serviceTypesRight = this.serviceTypesRightFinal.filter( (type) => type===serviceType);
    this.servicesStates = new Map<string, any>;
    const serviceState = {
      index: 0,
      state: 'closed'
    }
    this.servicesStates.set(serviceType, serviceState);
    this.dataSourceServices = new Map<string, MatTableDataSource<any>>;
    this.getListByType(serviceType);
  }

  loadServicesLists(){
    this.serviceTypesLeft = this.serviceTypesLeftFinal;
    this.serviceTypesRight = this.serviceTypesRightFinal;
    let i = 0;
    this.servicesStates = new Map<string, any>;
    this.dataSourceServices = new Map<string, MatTableDataSource<any>>;
    console.log(this.servicesDataMap);
    this.dataSourceSelectData = new Map<string, Select2Data>;
    this.paginatorServices = new QueryList<MatPaginator>
    this.managementService.getAllServiceLists().subscribe((response) => {
      const mappedResponse = new Map<string, any>(Object.entries(response));
      for(let i = 0; i<mappedResponse.size; i++){
        this.paginatorServices.reset([this.paginatorServices.toArray(), new MatPaginator(new MatPaginatorIntl(), this.changeDetectorRef)]);
      }
      mappedResponse.forEach((value:any, key:any) => {
        
        const dataSrc = new MatTableDataSource(value);
        switch(key){
          case "Procedures":
            i=0
            break;
          case "Requirements":
            i=1
            
            break;
          case "PidServiceCatalog":
            i=2
            break;
          case "ProcedureRequirements":
            i=3
            break;
          case "RequirementPidCatalog":
            i=4
            break;
        }
        const serviceState = {
          index: i,
          state: 'closed'
        }

        this.getSelect2Data(key, value);

        this.servicesStates.set(key, serviceState);
        dataSrc.paginator = this.paginator.toArray()[i];
        dataSrc.sort = this.sort.toArray()[i];
        this.dataSourceServices.set(key, dataSrc);
        
      })
      this.loadedData = true;
      console.log(this.dataSourceServices);
    })
  }

  saveServiceProperty(type:string, property:any){
    switch(type){
    case "Procedures":
      this.managementService.saveProcedure(property).subscribe({next:() => {
        this.visibleInputsProperties = false;
        this.getListByType("Procedures");
        this.editedEntry = {};
      }});
      break;
    case "Requirements":
      this.managementService.saveRequirement(property).subscribe({next:() => {
        this.visibleInputsProperties = false;
        this.getListByType("Requirements");
        this.editedEntry = {};
      }});
      break;
    case "PidServiceCatalog":
      this.managementService.savePidServiceCatalog(property).subscribe({next:() => {
        this.visibleInputsProperties = false;
        this.getListByType("PidServiceCatalog");
        this.editedEntry = {};
      }});
      break;
    case "ProcedureRequirements":
      this.managementService.saveProcedureRequirement(property).subscribe({next:() => {
        this.visibleInputsProperties = false;
        this.getListByType("ProcedureRequirements");
        this.editedEntry = {};
        this.editedValues = {};
      }});
      break;
    case "RequirementPidCatalog":
      this.managementService.saveRequirementPidCatalog(property).subscribe({next:() => {
        this.visibleInputsProperties = false;
        this.getListByType("RequirementPidCatalog");
        this.editedEntry = {};
        this.editedValues = {};
      }});
      break;
    }
  }

  openListByType(type: string){
    const index = this.servicesStates.get(type).index;
      if(index != undefined){
        const serviceState = {
          index: index,
          state: 'open'
        }
        this.servicesStates.set(type, serviceState);
      }
      
  }

  getListByType(type:string){
    this.managementService.getServiceListByType(type).subscribe((list) => {
      const index = this.servicesStates.get(type).index;
      if(index != undefined){
        const serviceState = {
          index: index,
          state: 'open'
        }
        this.servicesStates.set(type, serviceState);
        const dataSrc = new MatTableDataSource(list);
        dataSrc.paginator = this.paginator.toArray()[index];
        dataSrc.sort = this.sort.toArray()[index];
        this.dataSourceServices.set(type, dataSrc);
      }
    });
  }

  setServiceEditedEntry(serviceEntry: any, inputType?: string, type?: string) {
    this.editedEntry = structuredClone(serviceEntry);
    delete this.editedEntry.actions;

    this.editedValues = structuredClone(this.editedEntry);

    if (inputType === 'select' && type) {
      const attributeNames: string[] = this.servicesDataMap.get(type) ?? [];
      attributeNames.forEach(attributeName => {
        const value = serviceEntry[attributeName];
        if (value && typeof value === 'object') {
          this.editedValues[attributeName] = value.id;
        }
      });
    }

    this.visibleInputsProperties = true;
    console.log(this.editedEntry);
  }

  setServiceSavingEntry(type: string) {
    const mapObj = new Map<string, any>();
    const mapEdited = new Map<string, any>();
    const attributeNames: string[] = this.servicesDataMap.get(type) ?? [];
    const dataSrc = this.dataSourceServices.get(type);
    const data = dataSrc?.data ?? [];
    const modelObject = data[0];

    if (attributeNames.length === 0) {
      this.popUp = { show: true, title: "Error", message: "Unexpected error, cannot add entry" };
      setTimeout(() => (this.popUp.show = false), 4000);
      return;
    }

    const baseValueForAttribute = (attrName: string, isBoolean: boolean) =>
      isBoolean ? false : undefined;

    const fillMaps = (attrNames: string[], model?: any) => {
      attrNames.forEach(attrName => {
        const isBoolean = typeof model?.[attrName] === 'boolean';
        const baseValue = baseValueForAttribute(attrName, isBoolean);

        mapObj.set(attrName, baseValue);
        if (attrName !== 'actions') mapEdited.set(attrName, baseValue);
      });
    };

    fillMaps(attributeNames, modelObject);

    const serviceEntry: any = Object.fromEntries(mapObj.entries());
    serviceEntry.actions = 'new';

    const extendedData = [serviceEntry];
    this.dataSourceServices.set(type, new MatTableDataSource(extendedData));

    this.editedEntry = Object.fromEntries(mapEdited.entries());
    this.editedValues = Object.fromEntries(mapEdited.entries());

    this.visibleInputsProperties = true;
    console.log(this.dataSourceServices.get(type));
  }


  getSelect2Data(key:string, objList: any[]){
    if(objList[0].description != null){
      const dataList: Select2Data = objList.map((obj:any) => ({
        value: obj,
        label: obj.id + ': ' + obj.description,
      }));
      this.dataSourceSelectData.set(key, dataList);
    }
    else if(objList[0].serviceName != null){
      const dataList: Select2Data = objList.map((obj:any) => ({
        value: obj,
        label: obj.id + ': ' + obj.serviceName,
      }));
      this.dataSourceSelectData.set(key, dataList);
    }
    
  }

  setSelectedOption(event:Event, type:string, attr: string) {
    const serviceData = this.dataSourceServices.get(type)?.data ?? undefined;
    if(serviceData){
      const idEntry = Number((event.target as HTMLInputElement).value);
      this.editedEntry[attr] = serviceData.find(option => option.id === idEntry); 
    }
  }

  setSelectedOptionData(event:Select2UpdateEvent<Select2UpdateValue>, attr: string) {
    this.editedEntry[attr] = event.value; 
  }

  cancelSaveService(type:string){
    this.getListByType(type);
    this.visibleInputsProperties = false;
  }
  applyFilterService(event:Event, type:string){
    const dSource = this.dataSourceServices.get(type);
    if(dSource !== undefined && dSource.filter!==undefined){
      const filterValue = (event.target as HTMLInputElement).value;
      dSource.filter = filterValue.trim().toLowerCase();
      if (dSource.paginator) dSource.paginator.firstPage();
      this.dataSourceServices.set(type, dSource);
    }
    console.log(this.dataSourceServices)
  }

  closeTable(type: string){
    const index = this.servicesStates.get(type).index;
      if(index != undefined){
        const serviceState = {
          index: index,
          state: 'closed'
        }
        this.servicesStates.set(type, serviceState);
    }
  }

  deleteServiceEntry(type:string, id:number){
    this.managementService.deleteByIdAndType(type, id).subscribe({next: () =>{
      this.getListByType(type);
    }})
  }

  getServiceTypeByAttr(attr: string): string{
    let type = "";
    switch(attr){
      case ("requirementId"):
        type="Requirements"
        break;
      case ("procedureId"):
        type = "Procedures"
        break;
      case ("pidServiceId"):
        type = "PidServiceCatalog"
    }
    return type;
  }

  getServiceTypes(): string[]{
    return Array.from(this.servicesDataMap.keys());
  }

  translateAttrNames(name: string): string {
    name = name.charAt(0).toLowerCase() + name.slice(1);
    return name.replace(/([A-Z])/g, '_$1').toUpperCase().split('.')[0];
  }

  checkType(value: any, type: string): boolean{
    return typeof value === type;
  }

  listTemplates(){
    this.loadedData=false;
    this.managementService.listAllTemplates().subscribe({
      next: result => {
       this.baseData = result;
       this.dataSource = new MatTableDataSource(result);
       this.dataSource.paginator = this.paginator.toArray()[0];
       this.dataSource.sort = this.sort.toArray()[0];
       this.loadedData=true;
      }
   })
  }

  setTemplateData(i: number){
    const data = this.baseData[i];
    this.editedEntry = {
      id: data.id,
      templateName: data.templateName,
      templateBody: undefined
    }
  }
  

  setNewTemplateData(){
    this.editedEntry = {
      id: undefined,
      requirementId: undefined,
      templateName: undefined,
      templateBody: undefined
    }
    const extendedData = [];
                extendedData.push({id: "", requirement: "", templateName:"", actions: "new"});
                this.dataSource = new MatTableDataSource(extendedData);
  }

  async changeTemplate(event: any){

  const file: File = event.target.files?.item(0);
  if (!file) return;
  this.editedEntry.templateBody = await this.readFileContent(file);
  this.editedEntry.templateName = file.name;

    //this.editedEntry.bodyTemplate = await this.readFileContent(event.target.files.item(0))
  }

  readFileContent(file: File): Promise<string|undefined> {
    return new Promise<string|undefined>((retValue) => {
        if (!file) {
            retValue('');
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            const text = reader.result?.toString();
            retValue(text);

        };

        reader.readAsText(file);
    });
}

  updateTemplate(){
    this.editedEntry.templateBody = this.editedEntry.templateBody.replace(/[\n\r\t]/g, "")
    this.managementService.updateTemplate(this.editedEntry.id, this.editedEntry).subscribe({next:response => {
      this.listTemplates();
    } });
  }

  saveTemplate(){
    this.editedEntry.templateBody = this.editedEntry.templateBody.replace(/[\n\r\t]/g, "")
    this.editedEntry.requirementId = this.editedEntry.requirementId.id;
    this.managementService.saveTemplate(this.editedEntry).subscribe({next:response => {
      this.listTemplates();
    } });
  }

  changeCommonServiceValidation(){
    this.managementService.changeCommonServiceValidation(this.validationStatus).subscribe({ next: value => {
      this.popUp = {show: true, title: "Common services change", message: "The common services signature feature has changed"}
      setTimeout(() => this.popUp.show = false, 4000);
      }
    })
  }

  toConsoleLog(obj: any){
    console.log(obj)
  }
}
